export enum SapDataSource {
    Imported = "imported",
    Calculated = "calculated"
}

export enum SapCheckpointKind {
    Regular = "regular",
    FA = "fa",
    State = "state"
}

export const sapCheckpointKindOptions: Array<{id: SapCheckpointKind; name: string}> = [
    {id: SapCheckpointKind.Regular, name: "Regular SAP"},
    {id: SapCheckpointKind.FA, name: "FA SAP"},
    {id: SapCheckpointKind.State, name: "State SAP"}
]

export type SapCheckpointPayload = {
    programId: number
    programVersionIds: number[]
    shiftId?: number | null
    sapKind: SapCheckpointKind
    checkpoints: number[]
}

export type SapCheckpointProgram = {
    id: number
    name: string
    code?: string
}

export type SapCheckpointProgramVersion = {
    id: number
    versionName?: string
    version_name?: string
    versionCode?: string
    version_code?: string
}

export type SapCheckpointShift = {
    shiftId?: number
    id?: number
    name: string
}

export type SapCheckpoint = {
    sapCheckpointId?: number
    id?: number
    programId: number
    programVersionIds: number[]
    shiftId?: number | null
    sapKind: SapCheckpointKind
    checkpoints: number[]
    program?: SapCheckpointProgram
    programVersions?: SapCheckpointProgramVersion[]
    shift?: SapCheckpointShift
}

export type ListSapCheckpointsPayload = {
    filter?: Partial<{
        programIds: number[]
        programVersionIds: number[]
        shiftIds: number[]
        sapKind: SapCheckpointKind
    }>
    range?: {
        page: number
        pageSize: number
    }
    sort?: {
        orderBy: string
        orderDir: "asc" | "desc" | "ASC" | "DESC"
    }
    linkedEntities?: boolean | string[]
}
